<template>
<div v-if="totalEmployees != 0">
  <Chart :donut-center-render="'donutCenterRenderer'">
    <template v-slot:donutCenterRenderer>
      <span
        ><h5>Total: {{ totalEmployees }}</h5>
      </span>
    </template>
    <ChartTooltip :render="'renderTooltip'">
      <template v-slot:renderTooltip="{ props }">
        <div v-if="props">
          {{ props.point.category }} : {{ props.point.value }}
        </div>
      </template>
    </ChartTooltip>
    <ChartSeries>
      <ChartSeriesItem
        :type="'donut'"
        :data-items="items"
        :category-field="'label'"
        :field="'numberOfVehicle'"
        :holeSize="60"
      >
        <ChartSeriesLabels
          :background="'none'"
          :font="'10'"
          :content="labelContent"
        />
      </ChartSeriesItem>
    </ChartSeries>
    <ChartLegend :visible="true" />
  </Chart>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center w-100 h-100">
    <h4>No Data Available</h4>
  </div>
</template>
<script>
import {Chart,ChartLegend,ChartSeries,ChartSeriesItem,ChartSeriesLabels, ChartTooltip} from "@progress/kendo-vue-charts";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions, mapMutations, mapState } = createNamespacedHelpers("dashboard");

const labelContent = (e) =>  e.value;

export default {
  components: {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    ChartTooltip
  },
  data: function () {
    return {
      labelContent: labelContent,
    };
  },
  props: {
    selectedProduct: String,
    vehicles: Array,
    devices: Array,
    selectedTenant: String
  },
  computed: {
    dataItems() {
      if(this.selectedProduct == "VTS"){
        let vehicleData = this.$store.getters["dashboard/getTenantVehicles"];
        const data = vehicleData.filter(
          (vcl) => vcl.tenantId === this.selectedTenant
        );
          let totalDevices = data.length > 0 ? data[0].totalDevices : 0;
          let activeVehiclesCount = data.length > 0 ? data[0].mappedDevice : 0;
          let inActiveVehiclesCount = data.length > 0 ? data[0].unMappedDevice : 0; 
        return [{label: 'Total devices', numberOfVehicle: totalDevices}, {label: 'Mapped Devices', numberOfVehicle: activeVehiclesCount}, {label: 'Not Mapped Devices', numberOfVehicle: inActiveVehiclesCount}]
      }
      else{
        if(this.vehicles.length > 0){
          return [{label: 'Total vehicles', numberOfVehicle: this.vehicles[0].totalVehiclesCount}, {label: 'Active', numberOfVehicle: this.vehicles[0].activeVehiclesCount}, {label: 'Inactive', numberOfVehicle: this.vehicles[0].inActiveVehiclesCount}]
        }
        else{
            return [{label: 'Total vehicles', numberOfVehicle: 0}, {label: 'Active', numberOfVehicle: 0}, {label: 'Inactive', numberOfVehicle: 0}]
        }
      }
    },
    items() {
      let items = [...this.dataItems];
      items.shift();
      return items;
    },
    totalEmployees() {
      return this.dataItems[0]?.numberOfVehicle
        ? this.dataItems[0].numberOfVehicle
        : 0;
    },
  },
  methods: {
    ...mapState(["currentYear"]),
    ...mapActions(["getTenantDetailsOnProductName"]),
    ...mapMutations(["getNoOfVehicles","getNoOfEmployees"]),
    ...mapGetters(["getTenantVehicles","getTenantEmployees"]),
    // getDataOnLoad() {
    //   this.$store.dispatch("dashboard/getTenantDetailsOnProductName", this.selectedProduct);
    // },
  },
  mounted() {
    // this.getDataOnLoad();
  }
};
</script>